import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Typography,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  Button,
  TextField,
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import useStyles from "./styles";
import { AutoRegistrationContext } from "../../context/AutoRegistrationProvider";
import { useFormik } from "formik";

import { validationSchema, validationOtherCountrySchema } from "./validationSchema";

import statesBrasil from "./states.json";
import apiV2 from "../../../../api/api-client-v2";

export const StepTwo = () => {
  const [confirm, setConfirm] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([
    { cod_ibge: "-1", name: "Selecione a Cidade" },
  ]);

  const { setStep, data, setData } = useContext(AutoRegistrationContext);

  const classes = useStyles(loadingCities);

  const isTypeDocumentInternational = data?.typeDocument === "intl";

  const handleSubmitForm = (values) => {

    setData({ ...data, ...values });
    setStep(3);
  };

  const formik = useFormik({
    initialValues: {
      firstname: data?.firstname || "",
      lastname: data?.lastname || "",
      email: data?.email || "",
      country: data?.country || "-1",
      state: data?.state || "-1",
      city: data?.city || "-1",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema:
      isTypeDocumentInternational
        ? validationOtherCountrySchema
        : validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleGoBack = () => {
    setData({
      ...data,
      firstname: "",
      lastname: "",
      email: "",
      country: isTypeDocumentInternational ? "OTHER" : "BR",
      state: "-1",
      city: "-1",
    });
    setStep(1);
  };

  const handleChangeCountry = (e) => {
    formik.handleChange(e);
    setStates(statesBrasil);
  };

  useEffect(() => {
    if (formik.values.country === "-1") return;
    setStates(statesBrasil);
  }, [formik.values.country]);

  useEffect(() => {
    if (formik.values.state === "-1") return;

    setLoadingCities(true);
    apiV2
      .get(`cities/${formik.values.state}`)
      .then((response) => {
        setCities([
          { cod_ibge: "-1", name: "Selecione a Cidade" },
          ...response?.data,
        ]);
      })
      .finally(() => setLoadingCities(false));
  }, [formik.values.state]);

  const handleChangeState = (e) => {
    formik.handleChange(e);
  };

  const isDisabledBtn = () => {
    const { firstname, lastname, email, country, state, city } = formik.values;
    return !(
      !!firstname &&
      !!lastname &&
      !!email &&
      country !== "-1" &&
      state !== "-1" &&
      !!state &&
      city !== "-1" &&
      !!city &&
      confirm
    );
  };

  const isDisabledBtnOtherCountry = () => {
    const { firstname, lastname, email, country } = formik.values;
    return !(
      !!firstname &&
      !!lastname &&
      !!email &&
      country !== "-1" &&
      confirm
    );
  };

  const { firstname, lastname, email, country, state, city } = formik.values;

  return (
    <Box className={classes.registrationContainer}>
      <form onSubmit={formik.handleSubmit} className={classes.form}>
        <Box className={classes.inputContainer}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box className="firstname">
              <Typography variant="h5" align="left">
                Seu nome*
              </Typography>
              <TextField
                id="firstname-inp"
                data-cy="firstname-inp"
                name="firstname"
                value={firstname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.firstname}
                helperText={
                  !!formik.errors.firstname && formik.errors.firstname
                }
                variant="outlined"
                placeholder="Informe seu nome"
              />
            </Box>
            <Box className="lastname">
              <Typography variant="h5" align="left">
                Seu sobrenome*
              </Typography>
              <TextField
                id="lastname-inp"
                data-cy="lastname-inp"
                name="lastname"
                value={lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.errors.lastname}
                helperText={!!formik.errors.lastname && formik.errors.lastname}
                variant="outlined"
                placeholder="Informe seu sobrenome"
              />
            </Box>
          </Box>
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            E-mail*
          </Typography>
          <TextField
            id="email-inp"
            name="email"
            data-cy="email-inp"
            type="email"
            value={email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!formik.errors.email}
            helperText={!!formik.errors.email && formik.errors.email}
            variant="outlined"
            placeholder="Informe seu e-mail"
          />
        </Box>
        <Box className={classes.inputContainerCountry}>
          <FormControl className={classes.country}>
            <Typography variant="h5" align="left">
              País*
            </Typography>
            <Select
              id="country-slt"
              data-cy="country-slt"
              name="country"
              value={country}
              onChange={handleChangeCountry}
              onBlur={formik.handleBlur}
              error={!!formik.errors.country}
              variant="outlined"
            >
              <MenuItem value="-1" disabled>
                Selecione seu país
              </MenuItem>
              {isTypeDocumentInternational ? (
                <MenuItem value="OTHER" selected>
                  Outro
                </MenuItem>
              ) : (
                <MenuItem value="BR" selected>
                  Brasil
                </MenuItem>
              )}
            </Select>
          </FormControl>
          {!isTypeDocumentInternational && (
            <FormControl className={classes.uf}>
              <Typography variant="h5" align="left">
                UF*
              </Typography>
              <Select
                id="uf-slt"
                name="state"
                data-cy="uf-slt"
                value={state}
                onChange={handleChangeState}
                onBlur={formik.handleBlur}
                error={!!formik.errors.state}
                variant="outlined"
              >
                <MenuItem value="-1" disabled>
                  Selecione a UF
                </MenuItem>
                {states.map((state) => {
                  return (
                    <MenuItem key={state.uf} value={state.uf}>
                      {state.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}

        </Box>
        {!isTypeDocumentInternational && (
          <Box className={classes.inputContainer}>
            <Typography variant="h5" align="left">
              Cidade*
            </Typography>
            <FormControl>
              <Autocomplete
                id="city-slt"
                name="city"
                data-cy="city-slt"
                getOptionSelected={() => ({
                  cod_ibge: "-1",
                  name: "Selecione a Cidade",
                })}
                className={loadingCities ? classes.citySelect : ""}
                value={
                  cities.find((item) => item?.cod_ibge === city) || {
                    cod_ibge: "-1",
                    name: "Selecione a Cidade",
                  }
                }
                onChange={(_, value) => {
                  formik.setFieldValue("city", value?.cod_ibge);
                }}
                options={cities}
                loading={loadingCities}
                noOptionsText="Não conseguimos carregar nenhuma cidade."
                loadingText="Carregando..."
                disableClearable
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={formik.values.city}
                    error={!!formik.errors.city}
                    helperText={!!formik.errors.city && formik.errors.city}
                    label="Informe o local de carga ou descarga (ex: Cargill Uberlândia)"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Box>
        )}

        <Typography className={classes.info}>
          Lembre-se de que os dados informados serão armazenados pela Cargill
          para que possamos lhe prestar serviços e atender às suas solicitações.
          Para saber mais, acesse: <br />
          <a
            href="https://www.cargill.com/page/privacy-compromisso-privacidade"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://www.cargill.com/page/privacy-compromisso-privacidade
          </a>
        </Typography>
        <Box className={classes.confirm}>
          <Checkbox
            id="authorize-chk"
            data-cy="authorize-chk"
            value={confirm}
            onClick={() => setConfirm((previewState) => !previewState)}
            required
          />
          <Typography className={classes.confirmText}>
            Eu autorizo o armazenamento e uso dos meus dados pela Cargill.
          </Typography>
        </Box>
        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            className="goBack"
            color="primary"
            type="button"
            onClick={handleGoBack}
            size="large"
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Box className="goNext">
            *Preenchimento obrigatório.
            <Button
              id="next-btn"
              data-cy="next-btn"
              variant="contained"
              className="next"
              color="primary"
              size="large"
              type="submit"
              disabled={isTypeDocumentInternational
                ? isDisabledBtnOtherCountry()
                : isDisabledBtn()}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
